import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSirenAlarms = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 5.9L2.37 3.78L3.78 2.37L5.9 4.5L4.5 5.9ZM11.5 0V3H9.5V0H11.5ZM18.63 3.78L16.5 5.9L15.1 4.5L17.22 2.37L18.63 3.78V3.78ZM3 9.5V11.5H0V9.5H3ZM18 9.5H21V11.5H18V9.5ZM4.5 19H16.5C17.6 19 18.5 19.9 18.5 21H2.5C2.5 19.9 3.4 19 4.5 19ZM10.5 4C13.81 4 16.5 6.69 16.5 10V18H4.5V10C4.5 6.69 7.19 4 10.5 4Z",
		fill: "#C6CDD2"
	})
});
export default SvgSirenAlarms;
